import * as React from 'react';

import { Drawer } from '@mui/material';

import { track } from '@hbf/analytics';

import { AnalyticsEvent } from '@kamernet/core/Analytics/types';
import { useMediaIsDesktop } from '@kamernet/utilities/Media/useMediaIsDesktop';

import { useFilterSelectors } from '@kamernet/modules/Listing/context/hooks/useFilterSelectors';
import { ListingsContext } from '@kamernet/modules/Listing/context/ListingsContext';
import { SearchView } from '@kamernet/modules/Listing/types';

import { GridView } from '../GridView';
import { SearchMap } from '../Map/SearchMap';

import styles from './SearchViews.module.css';

export const SearchViews = () => {
  const isDesktop = useMediaIsDesktop();
  const { listingsState } = ListingsContext.useContext();
  const { isValidCity, getCityName } = useFilterSelectors();
  const isMapView = useFilterSelectors().isMapView();
  const [mobileGrid, setMobileGrid] = React.useState<boolean>(false);
  const openMobileGrid = React.useCallback(() => {
    setMobileGrid(true);
  }, []);
  const isListView =
    listingsState.filterResult.filters.searchview === SearchView.List;

  React.useEffect(() => {
    if (isValidCity() && isListView) {
      const cityName = getCityName();
      const trackPayload = {
        query: cityName,
        search_string: cityName,
      };
      track(AnalyticsEvent.SearchWithCity, trackPayload);
    }
  }, [isListView, isValidCity, getCityName]);

  return !isMapView ? (
    <GridView />
  ) : (
    <div className={styles.container}>
      <SearchMap openMobileGrid={openMobileGrid} />
      {isDesktop ? (
        <div className={styles.mapGridViewContainer}>
          <GridView className={styles.mapGridView} />
        </div>
      ) : (
        <Drawer
          classes={{ paperAnchorBottom: styles.bottomDrawer }}
          open={mobileGrid}
          anchor="bottom"
          aria-labelledby="Listing"
          aria-describedby="Listing"
          onClose={() => setMobileGrid(false)}
        >
          <GridView />
        </Drawer>
      )}
    </div>
  );
};
